import React from "react";
import Home from "../../../../common/assets/data/home";
import Section from "../../../utility/ui-components/section";
import Container from "../../../utility/ui-components/container";
import SectionHeading from "../../../utility/ui-components/sectionHeading";
import { Zoom } from "react-reveal";
function WhyChooseUs() {
  const data = Home.WhyChooseUs;
  return (
    <Section>
      <Container>
        {/* <Zoom> */}
        <SectionHeading heading={data.Heading} />
        {/* </Zoom> */}
        <div className=" grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 dropShadow-custom">
          {data &&
            data.ListItems.map((items, index) => (
              <div
                key={index + 1}
                className="group text-center md:text-start shadow-lg hover:bg-gray-light hover:transition-all  hover:shadow-lg p-3 rounded-xl border-[2px] border-solid border-primary"
              >
                <div className=" mx-auto  md:mx-[0px] w-[60px] h-[60px] group-hover:rounded-full hover:transition-all bg-tertiary flex items-center justify-center p-5 rounded-xl mb-3 dropShadow-3xl">
                  <img src={items.icon} />
                </div>
                <h4 className="text-sm md:text-1xl font-bold capitalize text-ellipsis text-primary mb-2">
                  {items.heading}
                </h4>
                <p className="text-base text-justify">{items.text}</p>
              </div>
            ))}
        </div>
      </Container>
    </Section>
  );
}

export default WhyChooseUs;
